// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"b3ee8414","499":"5bda37fc"}[chunkId] + ".chunk.js";
};